(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1128],{

/***/ 84137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useWindowEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useWindowEvent(type, listener, options) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    window.addEventListener(type, listener, options);
    return () => window.removeEventListener(type, listener, options);
  }, []);
}


//# sourceMappingURL=use-window-event.js.map


/***/ }),

/***/ 72128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useWindowScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84137);



function getScrollPosition() {
  return typeof window !== "undefined" ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function scrollTo({ x, y }) {
  if (typeof window !== "undefined") {
    const scrollOptions = { behavior: "smooth" };
    if (typeof x === "number") {
      scrollOptions.left = x;
    }
    if (typeof y === "number") {
      scrollOptions.top = y;
    }
    window.scrollTo(scrollOptions);
  }
}
function useWindowScroll() {
  const [position, setPosition] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getScrollPosition());
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("scroll", () => setPosition(getScrollPosition()));
  (0,_use_window_event_use_window_event_js__WEBPACK_IMPORTED_MODULE_1__/* .useWindowEvent */ .s)("resize", () => setPosition(getScrollPosition()));
  return [position, scrollTo];
}


//# sourceMappingURL=use-window-scroll.js.map


/***/ }),

/***/ 1646:
/***/ (function(module) {

!function(t,s){ true?module.exports=s():0}(this,(function(){"use strict";var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,u=31536e6,h=2592e6,a=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,d={years:u,months:h,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof p},f=function(t,s,n){return new p(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},g=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},p=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*d[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s]})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(a);if(e){var r=e.slice(2).map((function(t){return Number(t)}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*d[n]}),0)},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/u),t%=u,this.$d.months=$(t/h),t%=h,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t},y.toISOString=function(){var t=g(this.$d.years,"Y"),s=g(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=g(n,"D"),e=g(this.$d.hours,"H"),r=g(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3);var u=g(o,"S"),h=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",d=(h?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return"P"===d||"-P"===d?"P0D":d},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(o,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/d[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return"milliseconds"===n?s%=1e3:s="weeks"===n?$(s/d[n]):this.$d[n],0===s?0:s},y.add=function(t,s,n){var i;return i=s?t*d[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}();return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)&&(t=t.asMilliseconds()),r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)&&(t=t.asMilliseconds()),o.bind(this)(t,s)}}}));

/***/ }),

/***/ 43868:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding/[schoolId]",
      function () {
        return __webpack_require__(64549);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var _CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41972);
/* harmony import */ var _CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5__);








function CustomNextArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(className, " ").concat((_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().right_arrow)),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style),
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/svg/icon_openpath_arrow_right.svg",
            className: "hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
        })
    });
}
function CustomPrevArrow(props) {
    var className = props.className, style = props.style, onClick = props.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(className, " ").concat((_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().left_arrow)),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, style),
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/svg/icon_openpath_arrow_left.svg",
            className: "hidden lg:inline lg:h-13 lg:w-13 xl:h-18 xl:w-18"
        })
    });
}
var CarouselRender = function(param) {
    var imgList = param.imgList;
    var settings = {
        dots: true,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        touchMove: true,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomPrevArrow, {}),
        className: "openPathCarousel",
        // eslint-disable-next-line react/display-name
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                id: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().openPathDotContainer),
                children: dots
            });
        },
        // eslint-disable-next-line react/display-name
        customPaging: function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    id: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().openPathDot)
                })
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, settings), {
        children: imgList.map(function(url, idx) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_CarouselRend_module_scss__WEBPACK_IMPORTED_MODULE_5___default().img_container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: url,
                    className: "h-auto w-full px-12"
                })
            }, "".concat(url, "_").concat(idx));
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselRender);


/***/ }),

/***/ 32876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67804);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66305);
/* harmony import */ var _Dialog_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97105);
/* harmony import */ var _Dialog_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Dialog_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Dialog = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, title = param.title, message = param.message, customButton = param.customButton, customButtonEvent = param.customButtonEvent, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "확인" : _buttonText, _useCancelButton = param.useCancelButton, useCancelButton = _useCancelButton === void 0 ? false : _useCancelButton, _buttonClassName = param.buttonClassName, buttonClassName = _buttonClassName === void 0 ? "" : _buttonClassName, _hideCloseIcon = param.hideCloseIcon, hideCloseIcon = _hideCloseIcon === void 0 ? false : _hideCloseIcon, _transition = param.transition, transition = _transition === void 0 ? true : _transition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onClose: onClose,
        transition: transition,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "rounded-lg bg-white p-4 lg:p-5 ".concat((_Dialog_module_scss__WEBPACK_IMPORTED_MODULE_3___default().AlertDialogWrapper)),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-xl font-bold lg:text-2xl",
                            children: title
                        }),
                        !hideCloseIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "flex h-5 w-5 items-center justify-center",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .XIcon */ .b0D, {
                                className: "h-auto w-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "mt-4 box-border",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-sm lg:text-base ".concat((_Dialog_module_scss__WEBPACK_IMPORTED_MODULE_3___default().textWordBreak)),
                                children: message
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
                    className: "mt-4 flex justify-end",
                    children: [
                        !customButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                useCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "mr-3 flex items-center justify-center rounded-md border border-gray-300 px-5 py-3",
                                    onClick: onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-semibold",
                                        children: "취소"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "flex items-center justify-center rounded-md border border-gray-300 px-5 py-3 ".concat(buttonClassName),
                                    onClick: customButtonEvent || onClose,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-semibold",
                                        children: buttonText
                                    })
                                })
                            ]
                        }),
                        customButton
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dialog);


/***/ }),

/***/ 39949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67804);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);




var FAQPost = function(param) {
    var faq = param.faq, handler = param.handler, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    var onFAQOpenHandler = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        setIsOpen(!isOpen);
        if (handler) {
            handler();
        }
    }, [
        handler,
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "overflow-hidden rounded-lg border border-gray-200 bg-gray-50 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex cursor-pointer items-center px-4 py-3 lg:px-5 lg:py-4 ".concat(isOpen ? "border-b border-gray-200" : ""),
                onClick: onFAQOpenHandler,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex max-w-full flex-1 items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium lg:text-base ".concat(isOpen ? "" : "truncate"),
                            children: faq.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-auto pl-2",
                            children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronUpIcon */ .g8U, {
                                className: "h-auto w-5 shrink-0"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronDownIcon */ .v4q, {
                                className: "h-auto w-5 shrink-0"
                            })
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full bg-white px-4 py-4 lg:px-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-start",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "-mt-1 text-sm font-normal lg:text-base",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: faq.content
                                }
                            }),
                            faq.link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: faq.link.url,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "mt-4 block text-sm font-normal lg:text-base",
                                    rel: "noreferrer",
                                    children: faq.link.text
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var FAQAccordion = function(param) {
    var faqList = param.faqList, handler = param.handler, defaultOpenIdx = param.defaultOpenIdx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col space-y-2 lg:space-y-4",
            children: faqList === null || faqList === void 0 ? void 0 : faqList.map(function(faq, idx) {
                var defaultOpen = defaultOpenIdx === idx;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQPost, {
                    faq: faq,
                    defaultOpen: defaultOpen,
                    handler: handler
                }, faq.title);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQAccordion);


/***/ }),

/***/ 40840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34065);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53713);
/* harmony import */ var _CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var CourseHero = function(param) {
    var title = param.title, subTitle = param.subTitle, heroImg = param.heroImg, textColor = param.textColor;
    var isLaptop = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(min-width: 768px) and (max-width: 1023px)");
    var isTablet = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .a)("(max-width: 767px)");
    var sm = heroImg.sm, md = heroImg.md, lg = heroImg.lg;
    var getBgImg = function() {
        if (isTablet) {
            return sm;
        }
        if (isLaptop) {
            return md;
        }
        return lg;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mx-auto max-w-screen-2xl ".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroWrap)),
        style: {
            backgroundImage: "url(".concat(getBgImg(), ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mx-4 hidden h-full max-w-7xl flex-col justify-center md:flex xl:mx-auto xl:px-6",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 font-bold ".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroTitle), " break-words"),
                    style: !lodash__WEBPACK_IMPORTED_MODULE_1___default().isNull(textColor) ? {
                        color: "".concat(textColor)
                    } : {},
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "".concat((_CourseHero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().HeroSubTitle)),
                    style: !lodash__WEBPACK_IMPORTED_MODULE_1___default().isNull(textColor) ? {
                        color: "".concat(textColor)
                    } : {},
                    children: subTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseHero);


/***/ }),

/***/ 65097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67804);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var CurriculumItem = function(param) {
    var curriculumItem = param.curriculumItem, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    var onFAQOpenHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "overflow-hidden rounded-lg border border-gray-200 bg-gray-50 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex cursor-pointer items-center px-4 py-3 lg:px-5 lg:py-4 ".concat(isOpen ? "border-b border-gray-200" : ""),
                onClick: onFAQOpenHandler,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex max-w-full flex-1 items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm font-medium lg:text-base ".concat(isOpen ? "" : "truncate"),
                            children: curriculumItem.title
                        }),
                        isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronUpIcon */ .g8U, {
                            className: "ml-auto h-auto w-5 shrink-0"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_1__/* .ChevronDownIcon */ .v4q, {
                            className: "ml-auto h-auto w-5 shrink-0"
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full bg-white px-4 py-4 lg:px-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "-mt-1 whitespace-pre-wrap text-sm lg:text-base",
                            children: curriculumItem.content
                        }),
                        " "
                    ]
                })
            })
        ]
    });
};
var KDTCurriculum = function(param) {
    var curriculum = param.curriculum, defaultOpenIdx = param.defaultOpenIdx;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col space-y-2 lg:space-y-4",
            children: curriculum === null || curriculum === void 0 ? void 0 : curriculum.map(function(curriculumItem, idx) {
                var defaultOpen = defaultOpenIdx === idx;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CurriculumItem, {
                    curriculumItem: curriculumItem,
                    defaultOpen: defaultOpen
                }, curriculumItem.title);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KDTCurriculum);


/***/ }),

/***/ 93974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66261);
/* harmony import */ var _KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36833);
/* harmony import */ var _KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var GNBHeight = 64;
var navbarHeight = 48;
var ContentMarginTop = 40;
var KlassDetailNav = function(param) {
    var handler = param.handler, isFaq = param.isFaq, isCurriculum = param.isCurriculum, _isReview = param.isReview, isReview = _isReview === void 0 ? false : _isReview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("lecture-intro"), activeKey = ref[0], setActiveKey = ref[1];
    var onChangeKey = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(key) {
        return setActiveKey(key);
    }, []);
    var navList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var defaultNav = [
            {
                order: 1,
                label: "강의 소개",
                href: "#lecture-intro"
            }, 
        ];
        if (isCurriculum) {
            defaultNav.push({
                order: 2,
                label: "커리큘럼",
                href: "#curriculum"
            });
        }
        if (isReview) {
            defaultNav.push({
                order: 3,
                label: "수강후기",
                href: "#review"
            });
        }
        if (isFaq) {
            defaultNav.push({
                order: 4,
                label: "자주 묻는 질문",
                href: "#faq"
            });
        }
        return lodash__WEBPACK_IMPORTED_MODULE_1___default().sortBy(lodash__WEBPACK_IMPORTED_MODULE_1___default().uniqBy(defaultNav, "href"), "order");
    }, [
        isCurriculum,
        isFaq,
        isReview
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sticky z-20 mx-auto box-border max-w-screen-2xl border-b border-gray-200 bg-white ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().navContainer)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "mx-auto max-w-7xl xl:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "flex overflow-x-auto whitespace-nowrap px-4 pt-3 lg:px-6 xl:px-0 ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().scrollNo)),
                children: navList.map(function(param) {
                    var label = param.label, href = param.href;
                    var key = href.slice(1);
                    var isActive = activeKey === key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "flex flex-col ".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().navItem), " relative"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "font-base block cursor-pointer ".concat(isActive ? "".concat((_KlassDetailNav_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isActiveNav), " pb-3 text-primary-normal") : "text-gray-500"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                                to: key,
                                spy: true,
                                smooth: true,
                                onClick: function() {
                                    if (handler) {
                                        handler();
                                    }
                                },
                                onSetActive: function() {
                                    onChangeKey(key);
                                },
                                offset: -(GNBHeight + navbarHeight + ContentMarginTop),
                                children: label
                            })
                        })
                    }, key);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KlassDetailNav);


/***/ }),

/***/ 28342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66607);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var designs_Loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3790);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var shared_contexts_Auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96759);
/* harmony import */ var _queries_useKDCApplyMutation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24743);
/* harmony import */ var _queries_useKDCAttrQuery__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68620);
/* harmony import */ var _queries_useMyKDCApplyQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67824);















dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_2___default()));
var useKDCApply = function(courseId) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref = (0,shared_contexts_Auth__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)(), profile = ref.profile, isSigned = ref.isSigned, signInUrl = ref.signInUrl;
    var prevLocation = router.query.prevLocation || "/";
    var kdcApply = (0,_queries_useKDCApplyMutation__WEBPACK_IMPORTED_MODULE_9__/* .useKDCApplyMutation */ .F)();
    var ref1 = (0,_queries_useKDCAttrQuery__WEBPACK_IMPORTED_MODULE_10__/* .useKDCAttrQuery */ .s)(courseId), kdcAttr = ref1.data, isKdcAttrLoading = ref1.isLoading;
    var checkSignIn = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function() {
        var state = qs__WEBPACK_IMPORTED_MODULE_6___default().stringify({
            state: location.pathname
        });
        var signInUrlWithState = "".concat(signInUrl, "&").concat(state, "&register_from=").concat(prevLocation);
        window.location.replace(signInUrlWithState);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(designs_Loading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
    }, [
        prevLocation,
        signInUrl
    ]);
    var submitApply = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function(data) {
        var gclid = JSON.parse(localStorage.getItem("gclid"));
        kdcApply.mutate((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
            courseId: data === null || data === void 0 ? void 0 : data.courseId,
            kdcAttrId: data === null || data === void 0 ? void 0 : data.id,
            userId: profile === null || profile === void 0 ? void 0 : profile.id
        }, !lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty(gclid) && {
            gclid: gclid.gclid
        }), {
            onSuccess: function() {
                if (!(profile === null || profile === void 0 ? void 0 : profile.isCertificated)) {
                    void router.push("/onboarding/".concat(data.courseId, "/apply/identity-verification"));
                } else {
                    void router.push("/onboarding/".concat(data.courseId, "/apply/card"));
                }
            }
        });
    }, [
        kdcApply,
        profile,
        router
    ]);
    var onApply = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(curId, onDialogOpen) {
            var ref, myApply, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!isSigned) return [
                            3,
                            1
                        ];
                        checkSignIn();
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty(kdcAttr) && kdcAttr)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,_queries_useMyKDCApplyQuery__WEBPACK_IMPORTED_MODULE_11__/* .fetchMyKDCApply */ .A)((ref = kdcAttr[0]) === null || ref === void 0 ? void 0 : ref.id)
                        ];
                    case 2:
                        myApply = _state.sent();
                        if (lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty(myApply)) {
                            submitApply(kdcAttr[0]);
                        } else {
                            ;
                            if (!(profile === null || profile === void 0 ? void 0 : profile.isCertificated)) {
                                void router.push("/onboarding/".concat(curId, "/apply/identity-verification"));
                            } else if ((profile === null || profile === void 0 ? void 0 : profile.isCertificated) && (lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref1 = myApply[0]) === null || ref1 === void 0 ? void 0 : ref1.hrdInfo) || lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref2 = myApply[0]) === null || ref2 === void 0 ? void 0 : ref2.hrdInfo.haveCardAt))) {
                                void router.push("/onboarding/".concat(curId, "/apply/card"));
                            } else if (!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref3 = myApply[0]) === null || ref3 === void 0 ? void 0 : ref3.hrdInfo.haveCardAt) && lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref4 = myApply[0]) === null || ref4 === void 0 ? void 0 : ref4.passedAt)) {
                                void router.push("/onboarding/".concat(curId, "/apply/enrollment"));
                            } else if (!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref5 = myApply[0]) === null || ref5 === void 0 ? void 0 : ref5.passedAt) && lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref6 = myApply[0]) === null || ref6 === void 0 ? void 0 : ref6.paidAt)) {
                                void router.push({
                                    pathname: "/onboarding/".concat(curId, "/apply/payment"),
                                    query: {
                                        schoolId: curId,
                                        startedAt: kdcAttr[0].startedAt
                                    }
                                }, "/onboarding/".concat(curId, "/apply/payment"));
                            } else if (!lodash__WEBPACK_IMPORTED_MODULE_4___default().isEmpty((ref7 = myApply[0]) === null || ref7 === void 0 ? void 0 : ref7.paidAt)) {
                                if (onDialogOpen) {
                                    void onDialogOpen();
                                }
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(curId, onDialogOpen) {
            return _ref.apply(this, arguments);
        };
    }(), [
        checkSignIn,
        isSigned,
        kdcAttr,
        profile,
        router
    ]);
    return {
        onApply: onApply,
        isKdcAttrLoading: isKdcAttrLoading,
        kdcAttr: kdcAttr,
        checkSignIn: checkSignIn,
        isSigned: isSigned,
        profile: profile
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useKDCApply);


/***/ }),

/***/ 24743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useKDCApplyMutation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48228);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_convertString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79379);





var updateKDCApply = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        var resp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(window.apiEndpoint, "/my/course/v1/kdc-applies"), (0,utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .convertCaseList */ ._b)(data, utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .ConvertType.SNAKE */ .xb.SNAKE))
                    ];
                case 1:
                    resp = _state.sent();
                    return [
                        2,
                        (0,utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .convertCaseList */ ._b)(resp, utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .ConvertType.CAMEL */ .xb.CAMEL)
                    ];
            }
        });
    });
    return function updateKDCApply(data) {
        return _ref.apply(this, arguments);
    };
}();
var useKDCApplyMutation = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useMutation */ .D)(updateKDCApply);
};


/***/ }),

/***/ 67824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ fetchMyKDCApply; },
/* harmony export */   "V": function() { return /* binding */ useMyKDCApplyQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36492);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_convertString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79379);





var fetchMyKDCApply = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(id) {
        var resp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(id !== "")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(window.apiEndpoint, "/my/course/v1/kdc-applies?filters=kdc_attr_id:").concat(id))
                    ];
                case 1:
                    resp = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        (0,utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .convertCaseList */ ._b)(resp === null || resp === void 0 ? void 0 : resp.data, utils_convertString__WEBPACK_IMPORTED_MODULE_1__/* .ConvertType.CAMEL */ .xb.CAMEL)
                    ];
            }
        });
    });
    return function fetchMyKDCApply(id) {
        return _ref.apply(this, arguments);
    };
}();
var useMyKDCApplyQuery = function(id) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
        queryKey: [
            "myKDCApply",
            id
        ],
        queryFn: function() {
            return fetchMyKDCApply(id);
        },
        retry: function() {
            return id === "" ? true : false;
        }
    });
};


/***/ }),

/***/ 64549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _schoolId_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(67804);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(34065);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-window-scroll/use-window-scroll.js
var use_window_scroll = __webpack_require__(72128);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./features/onboarding/hooks/useKDCApply.tsx
var useKDCApply = __webpack_require__(28342);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./mocks/kdt.ts
var kdt = __webpack_require__(96800);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-gtm-module/dist/index.js
var dist = __webpack_require__(1785);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/sec2time.ts
var sec2time = __webpack_require__(76002);
// EXTERNAL MODULE: ./components/CourseInfo/KlassInfoHeader.tsx + 2 modules
var KlassInfoHeader = __webpack_require__(94501);
;// CONCATENATED MODULE: ./components/CourseInfo/CourseInfoKDC.tsx













dayjs_min_default().locale("ko");
var CourseInfoKDC = function(param) {
    var course = param.course, isMobile = param.isMobile, curEpisode = param.curEpisode, onCompleteDialogOpenHandler = param.onCompleteDialogOpenHandler;
    var title = course.title, price = course.price, panelText = course.panelText, totalSeconds = course.totalSeconds, id = course.id, shareUrl = course.shareUrl, imageM = course.imageM;
    var onApply = (0,useKDCApply/* default */.Z)(id).onApply;
    var curPrice = price.toLocaleString();
    var ref = (0,react.useState)(null), openAddition = ref[0], setOpenAddition = ref[1];
    var handleItemClick = function(itemId) {
        setOpenAddition(itemId === openAddition ? null : itemId);
    };
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_window_scroll/* useWindowScroll */.b)(), 1), scroll = ref1[0];
    var detailInfoList = (0,react.useMemo)(function() {
        return [
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CalendarIcon */.Que, {
                    className: "h-5 w-5"
                }),
                title: "수강기간",
                content: "".concat(dayjs_min_default()(curEpisode === null || curEpisode === void 0 ? void 0 : curEpisode.startedAt).format("MM.DD"), " ~ ").concat(dayjs_min_default()(curEpisode === null || curEpisode === void 0 ? void 0 : curEpisode.endedAt).format("MM.DD"), " ").concat([
                    "kdc-datadata"
                ].includes(course.id) ? "(수료 시 1년연장)" : "(수료 시 평생소장)")
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ClockIcon */.T39, {
                    className: "h-5 w-5"
                }),
                title: "강의분량",
                content: "".concat((0,sec2time/* sec2time */.b)(totalSeconds !== null && totalSeconds !== void 0 ? totalSeconds : 0, "H시간 mm분"))
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* HomeIcon */.tvw, {
                    className: "h-5 w-5"
                }),
                title: "수강방식",
                content: "온라인"
            },
            {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ClipboardCheckIcon */.C2q, {
                    className: "h-5 w-5"
                }),
                title: "모집기간",
                content: "".concat(dayjs_min_default()(curEpisode === null || curEpisode === void 0 ? void 0 : curEpisode.applyStartedAt).format("MM.DD"), " ~ ").concat(dayjs_min_default()(curEpisode === null || curEpisode === void 0 ? void 0 : curEpisode.applyEndedAt).format("MM.DD a hh시"))
            }, 
        ];
    }, [
        course,
        curEpisode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: course && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "block border-b lg:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-4 pb-6 pt-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                                        isMobile: true,
                                        klassId: id,
                                        title: title,
                                        panelText: panelText,
                                        shareUrl: shareUrl,
                                        imgUrl: imageM
                                    }),
                                    panelText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-[18px] break-keep border-b border-gray-300 py-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm text-gray-500",
                                            children: panelText
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col space-y-3",
                                        children: detailInfoList.map(function(param, idx) {
                                            var icon = param.icon, title = param.title, content = param.content;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "inline-flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: icon
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "ml-2 min-w-12.5 font-semibold",
                                                                children: title
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-2 mr-1 whitespace-nowrap",
                                                        children: content
                                                    })
                                                ]
                                            }, "".concat(title, "_").concat(idx));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-4 mb-6 flex flex-col gap-y-2 lg:mt-5",
                                children: kdt/* AdditionalList.kdc.map */.jh.kdc.map(function(addition) {
                                    var isOpen = openAddition === addition.id;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "cursor-pointer rounded-lg bg-gray-50 px-4 py-3",
                                        onClick: function() {
                                            return handleItemClick(addition.id);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-between gap-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-center gap-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex h-6 w-6 items-center justify-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: addition.icon,
                                                                    alt: addition.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "text-sm font-bold",
                                                                children: [
                                                                    addition.boldTitle,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "ml-1 inline-block font-normal",
                                                                        children: addition.title
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                                        className: "".concat(isOpen ? "" : "rotate-180 transform", " w-4 text-gray-400")
                                                    })
                                                ]
                                            }),
                                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-4 flex flex-col gap-y-1.5",
                                                children: [
                                                    addition.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-xs font-semibold",
                                                        children: addition.summary
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-semibold",
                                                                children: addition.boldDesc
                                                            }),
                                                            addition.desc
                                                        ]
                                                    }),
                                                    addition.secondSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-2.5 text-xs font-semibold",
                                                        children: addition.secondSummary
                                                    }),
                                                    addition.secondDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-xs text-gray-500",
                                                        children: addition.secondDesc
                                                    }),
                                                    addition.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-xs text-gray-500",
                                                        children: addition.reference
                                                    })
                                                ]
                                            })
                                        ]
                                    }, addition.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed bottom-0 left-0 z-30 block w-full bg-white shadow-[0px_-1px_4px_0px_rgba(0,0,0,0.05)] lg:hidden",
                        style: {
                            minWidth: 320
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between px-4 py-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold text-red-450",
                                                    children: "90%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pl-1 text-gray-400 line-through",
                                                    children: [
                                                        curPrice,
                                                        "원"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "text-lg font-semibold",
                                                    children: [
                                                        (Math.round(price * 0.1 / 10) * 10).toLocaleString(),
                                                        "원"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-[6px] inline-block rounded bg-red-100 px-[6px] py-[2px] text-xs font-semibold text-red-450",
                                                    children: [
                                                        "kdc-datadata"
                                                    ].includes(course.id) ? "수료 시 1년연장" : "수료 시 평생소장"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    disabled: lodash_default().isEmpty(curEpisode),
                                    onClick: function() {
                                        void onApply(id, onCompleteDialogOpenHandler);
                                        dist_default().dataLayer({
                                            dataLayer: (0,_object_spread/* default */.Z)({
                                                event: "kdc_apply_btn_click",
                                                content_ids: id
                                            }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
                                        });
                                    },
                                    className: "ml-4 w-full rounded-md px-6 py-[10px] ".concat(lodash_default().isEmpty(curEpisode) ? "cursor-not-allowed bg-gray-300" : "bg-primary-normal"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-base font-semibold text-white md:text-lg",
                                        children: lodash_default().isEmpty(curEpisode) ? "수강 마감" : "수강 신청하기"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-4 pt-5 lg:rounded-lg lg:border lg:border-gray-300 lg:p-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassInfoHeader/* default */.Z, {
                            isMobile: false,
                            klassId: id,
                            title: title,
                            panelText: panelText,
                            shareUrl: shareUrl,
                            imgUrl: imageM
                        }),
                        panelText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-[18px] break-keep border-b border-gray-300 py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm text-gray-500",
                                children: panelText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col space-y-3",
                            children: detailInfoList.map(function(param, idx) {
                                var icon = param.icon, title = param.title, content = param.content;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-center text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inline-flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-2 min-w-12.5 font-semibold",
                                                    children: title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 mr-1 whitespace-nowrap",
                                            children: content
                                        })
                                    ]
                                }, "".concat(title, "_").concat(idx));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "my-4 border-gray-300"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "flex text-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold text-red-450",
                                    children: "90%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "pl-1 text-gray-400 line-through",
                                    children: [
                                        curPrice,
                                        "원"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-xl font-bold",
                                    children: [
                                        (Math.round(price * 0.1 / 10) * 10).toLocaleString(),
                                        "원"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 inline-block rounded bg-red-100 px-[6px] py-[2px] text-sm font-semibold text-red-450",
                                    children: [
                                        "kdc-datadata"
                                    ].includes(course.id) ? "수료 시 1년연장" : "수료 시 평생소장"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            disabled: lodash_default().isEmpty(curEpisode),
                            onClick: function() {
                                void onApply(id, onCompleteDialogOpenHandler);
                                dist_default().dataLayer({
                                    dataLayer: (0,_object_spread/* default */.Z)({
                                        event: "kdc_apply_btn_click",
                                        content_ids: id
                                    }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
                                });
                            },
                            className: "mt-[18px] w-full rounded-md p-2 ".concat(lodash_default().isEmpty(curEpisode) ? "cursor-not-allowed bg-gray-300" : "bg-primary-normal"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base font-semibold text-white md:text-lg",
                                children: lodash_default().isEmpty(curEpisode) ? "수강 마감" : "수강 신청하기"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CourseInfo_CourseInfoKDC = (CourseInfoKDC);

// EXTERNAL MODULE: ./components/DetailRender/CarouselRender.tsx
var CarouselRender = __webpack_require__(27279);
// EXTERNAL MODULE: ./components/DetailRender/HTMLRender.tsx
var HTMLRender = __webpack_require__(97205);
// EXTERNAL MODULE: ./components/Dialog/index.tsx
var Dialog = __webpack_require__(32876);
// EXTERNAL MODULE: ./components/FAQAccordion/index.tsx
var FAQAccordion = __webpack_require__(39949);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isSameOrAfter.js
var isSameOrAfter = __webpack_require__(79212);
var isSameOrAfter_default = /*#__PURE__*/__webpack_require__.n(isSameOrAfter);
// EXTERNAL MODULE: ./designs/CourseHero/index.tsx
var CourseHero = __webpack_require__(40840);
// EXTERNAL MODULE: ./designs/Loading/index.tsx
var Loading = __webpack_require__(3790);
// EXTERNAL MODULE: ./features/apply/components/KDTCurriculum.tsx
var KDTCurriculum = __webpack_require__(65097);
// EXTERNAL MODULE: ./features/klass/components/KlassDetailNav/index.tsx
var KlassDetailNav = __webpack_require__(93974);
// EXTERNAL MODULE: ./features/onboarding/queries/useKDCAttrQuery.tsx
var useKDCAttrQuery = __webpack_require__(68620);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/gtm/hooks/useViewItem.ts
var useViewItem = __webpack_require__(12083);
// EXTERNAL MODULE: ./shared/hooks/useCourse.tsx
var useCourse = __webpack_require__(98082);
// EXTERNAL MODULE: ./shared/hooks/useCourseFaqList.tsx
var useCourseFaqList = __webpack_require__(77750);
// EXTERNAL MODULE: ./shared/hooks/useDialog.tsx
var useDialog = __webpack_require__(39703);
// EXTERNAL MODULE: ./shared/layout/WithHeader/index.tsx + 1 modules
var WithHeader = __webpack_require__(89123);
// EXTERNAL MODULE: ./pages/onboarding/[schoolId]/kdcDetail.module.scss
var kdcDetail_module = __webpack_require__(9983);
var kdcDetail_module_default = /*#__PURE__*/__webpack_require__.n(kdcDetail_module);
;// CONCATENATED MODULE: ./pages/onboarding/[schoolId]/index.tsx



























dayjs_min_default().extend((isSameOrAfter_default()));
var KDCDetail = function() {
    var ref, ref1;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: 1023px)");
    var ref2 = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var schoolId = (0,react.useMemo)(function() {
        return router.query.schoolId;
    }, [
        router
    ]);
    var ref3 = (0,useKDCAttrQuery/* useKDCAttrQuery */.s)(schoolId), curEpisode = ref3.data, curEpisodeLoading = ref3.isLoading;
    var ref4 = (0,useCourse/* useCourse */.T)(schoolId), kdcData = ref4.course, kdcLoading = ref4.isLoading;
    var courseFAQList = (0,useCourseFaqList/* useCourseFaqList */.$)(schoolId).courseFAQList;
    var ref5 = (0,useDialog/* useDialog */.R)(), isCompleteDialogOpen = ref5.isDialogOpened, onCompleteDialogOpenHandler = ref5.onDialogOpenHandler, onCompleteDialogCloseHandler = ref5.onDialogCloseHandler;
    var ref6 = (0,react.useState)(null), openAddition = ref6[0], setOpenAddition = ref6[1];
    var handleItemClick = function(itemId) {
        setOpenAddition(itemId === openAddition ? null : itemId);
    };
    var onFAQHandler = (0,react.useCallback)(function() {
        dist_default().dataLayer({
            dataLayer: (0,_object_spread/* default */.Z)({
                event: "frequently_asked_click",
                content_ids: schoolId
            }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
        });
    }, [
        schoolId
    ]);
    var onNaviHandler = function() {
        dist_default().dataLayer({
            dataLayer: (0,_object_spread/* default */.Z)({
                event: "upper_navigator_click",
                content_ids: schoolId
            }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
        });
    };
    (0,useViewItem/* useViewItem */.f)(kdcData, schoolId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WithHeader/* default */.Z, {
                children: [
                    kdcLoading && curEpisodeLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        ref: ref2,
                        style: {
                            minWidth: 360,
                            marginBottom: isMobile ? 80 : 160
                        },
                        children: [
                            kdcData && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseHero/* default */.Z, {
                                title: kdcData.title,
                                subTitle: kdcData.subtitle,
                                heroImg: {
                                    sm: kdcData.bannerBgImgS,
                                    md: kdcData.bannerBgImgM,
                                    lg: kdcData.bannerBgImg
                                },
                                textColor: kdcData.bannerTextColor
                            }),
                            !lodash_default().isEmpty(kdcData) && curEpisode && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseInfo_CourseInfoKDC, {
                                isMobile: true,
                                course: kdcData,
                                curEpisode: curEpisode[0],
                                onCompleteDialogOpenHandler: onCompleteDialogOpenHandler
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KlassDetailNav/* default */.Z, {
                                handler: onNaviHandler,
                                isReview: false,
                                isCurriculum: !lodash_default().isEmpty(kdcData === null || kdcData === void 0 ? void 0 : kdcData.curriculum),
                                isFaq: !lodash_default().isEmpty(courseFAQList)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 max-w-7xl lg:mt-6 lg:px-4 xl:mx-auto xl:px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:flex lg:flex-row lg:items-start lg:space-x-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "lecture-intro",
                                                    style: {
                                                        maxWidth: isMobile ? "100%" : 848
                                                    },
                                                    className: (kdcDetail_module_default()).container,
                                                    children: kdcData && kdcData.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLRender/* default */.Z, {
                                                        html: kdcData.description
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: kdcData === null || kdcData === void 0 ? void 0 : (ref = kdcData.descriptionObjects) === null || ref === void 0 ? void 0 : ref.map(function(param, idx) {
                                                            var type = param.type, data = param.data;
                                                            return type === "html" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLRender/* default */.Z, {
                                                                html: data
                                                            }, "".concat(type, "_").concat(idx)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRender/* default */.Z, {
                                                                imgList: data
                                                            }, "".concat(type, "_").concat(idx));
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mx-4 lg:mx-0",
                                                    children: [
                                                        kdcData && !lodash_default().isEmpty(kdcData === null || kdcData === void 0 ? void 0 : kdcData.curriculum) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            id: "curriculum",
                                                            className: "mt-20 lg:mt-30",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                                                    className: "flex flex-col lg:flex-row lg:items-end",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                        className: "text-xl font-bold lg:text-2xl",
                                                                        style: {
                                                                            lineHeight: "30px"
                                                                        },
                                                                        children: "커리큘럼"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mt-4 lg:mt-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KDTCurriculum/* default */.Z, {
                                                                        curriculum: kdcData.curriculum,
                                                                        defaultOpenIdx: 0
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        !lodash_default().isEmpty(courseFAQList) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            id: "faq",
                                                            className: "mt-20 lg:mt-30",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "text-xl font-bold lg:text-2xl",
                                                                    children: "자주 묻는 질문"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                                    className: "mt-4 lg:mt-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQAccordion/* default */.Z, {
                                                                        faqList: courseFAQList,
                                                                        defaultOpenIdx: 0,
                                                                        handler: onFAQHandler
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                            className: "hidden h-auto shrink-0 lg:sticky lg:block",
                                            style: {
                                                top: 138,
                                                width: 360
                                            },
                                            children: [
                                                !lodash_default().isEmpty(kdcData) && curEpisode && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseInfo_CourseInfoKDC, {
                                                    course: kdcData,
                                                    curEpisode: curEpisode[0],
                                                    onCompleteDialogOpenHandler: onCompleteDialogOpenHandler
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-6 flex flex-col gap-y-2 lg:mt-5",
                                                    children: kdt/* AdditionalList.kdc.map */.jh.kdc.map(function(addition) {
                                                        var isOpen = openAddition === addition.id;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                            className: "cursor-pointer rounded-lg bg-gray-50 px-4 py-3",
                                                            onClick: function() {
                                                                return handleItemClick(addition.id);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex items-center justify-between gap-x-2",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "flex items-center gap-x-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "flex h-6 w-6 items-center justify-center",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: addition.icon,
                                                                                        alt: addition.title
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "text-sm font-bold",
                                                                                    children: [
                                                                                        addition.boldTitle,
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "ml-1 inline-block font-normal",
                                                                                            children: addition.title
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                                                            className: "".concat(isOpen ? "" : "rotate-180 transform", " w-4 text-gray-400")
                                                                        })
                                                                    ]
                                                                }),
                                                                isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-4 flex flex-col gap-y-1.5",
                                                                    children: [
                                                                        addition.summary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-sm font-semibold",
                                                                            children: addition.summary
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                            className: "text-sm text-gray-500",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "font-semibold",
                                                                                    children: addition.boldDesc
                                                                                }),
                                                                                addition.desc
                                                                            ]
                                                                        }),
                                                                        addition.secondSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "mt-2.5 text-sm font-semibold",
                                                                            children: addition.secondSummary
                                                                        }),
                                                                        addition.secondDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "text-sm text-gray-500",
                                                                            children: addition.secondDesc
                                                                        }),
                                                                        addition.reference && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-sm text-gray-500",
                                                                            children: addition.reference
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, addition.id);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                isOpen: isCompleteDialogOpen,
                onClose: onCompleteDialogCloseHandler,
                title: "신청 완료",
                message: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-4 overflow-y-auto md:mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "box-border pb-4 md:pb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "break-keep text-sm md:text-base",
                            children: [
                                "최종 수강생이 되셨습니다! ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                dayjs_min_default()(curEpisode && ((ref1 = curEpisode[0]) === null || ref1 === void 0 ? void 0 : ref1.startedAt)).format("M월 D일"),
                                "부터 내 강의실에서 학습을 시작할 수 있어요."
                            ]
                        })
                    })
                }),
                customButton: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full justify-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function() {
                            return router.push("/my/courses");
                        },
                        className: "rounded-md border border-trueGray-300 px-5 py-3 text-sm font-semibold",
                        children: "내 강의실 가기"
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _schoolId_ = (KDCDetail);


/***/ }),

/***/ 12083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useViewItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7316);





// GA 향상된 전자상거래 - enhanced ecommerce
// GA4 전자상거래 - ecommerce
var useViewItem = function(course, courseId) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isPushed = ref[0], setIsPushed = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(course) || course.id !== courseId || isPushed) return;
        react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer({
            dataLayer: {
                ecommerce: null
            }
        });
        // GA4
        react_gtm_module__WEBPACK_IMPORTED_MODULE_2___default().dataLayer({
            dataLayer: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                event: "view_item",
                ecommerce: {
                    items: [
                        (0,utils_convertFormatForGTM__WEBPACK_IMPORTED_MODULE_3__/* .convertToEcommerceItem */ .Gn)(course)
                    ]
                }
            }, sessionStorage.getItem("utmAndGclid") && JSON.parse(sessionStorage.getItem("utmAndGclid")))
        });
        setIsPushed(true);
    }, [
        course,
        courseId,
        isPushed
    ]);
};


/***/ }),

/***/ 98082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useCourse; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82332);
/* harmony import */ var _stores_courses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70957);




var useCourse = function(courseId) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.courses;
    }), isLoading = ref.isLoading, course = ref.course;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(courseId) && (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(course) || !lodash__WEBPACK_IMPORTED_MODULE_0___default().isEqual(course === null || course === void 0 ? void 0 : course.id, courseId))) {
            dispatch((0,_stores_courses__WEBPACK_IMPORTED_MODULE_3__/* .fetchCourseDetailThunk */ .Ik)(courseId));
        }
    }, [
        courseId,
        course,
        dispatch
    ]);
    return {
        isLoading: isLoading,
        course: course
    };
};


/***/ }),

/***/ 77750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useCourseFaqList; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82332);
/* harmony import */ var _stores_courses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70957);




var useCourseFaqList = function(courseId) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.courses;
    }), isLoading = ref.isLoading, courseFAQList = ref.faqList;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(courseId)) {
            dispatch((0,_stores_courses__WEBPACK_IMPORTED_MODULE_3__/* .fetchCourseFAQListThunk */ .g_)(courseId));
        }
    }, [
        courseId,
        dispatch
    ]);
    return {
        isLoading: isLoading,
        courseFAQList: courseFAQList
    };
};


/***/ }),

/***/ 41972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"left_arrow":"CarouselRend_left_arrow___46VZ","right_arrow":"CarouselRend_right_arrow__GLUMP","img_container":"CarouselRend_img_container__UlePo","openPathDotContainer":"CarouselRend_openPathDotContainer__zeDn7","openPathDot":"CarouselRend_openPathDot__TYd0D"};

/***/ }),

/***/ 97105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AlertDialogWrapper":"Dialog_AlertDialogWrapper__yWkY_","textWordBreak":"Dialog_textWordBreak__qadI8"};

/***/ }),

/***/ 53713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroWrap":"CourseHero_HeroWrap__7r73W","HeroTitle":"CourseHero_HeroTitle__8_Yjh","HeroSubTitle":"CourseHero_HeroSubTitle__K6Tju"};

/***/ }),

/***/ 36833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scrollNo":"KlassDetailNav_scrollNo__UkYR0","navContainer":"KlassDetailNav_navContainer__bn8_o","navItem":"KlassDetailNav_navItem__XliVY","isActiveNav":"KlassDetailNav_isActiveNav__uefvi"};

/***/ }),

/***/ 9983:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kdcDetail_container__ErU18"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,6408,4653,3607,346,5966,9464,4872,6261,2881,3881,1481,6800,5202,9774,2888,179], function() { return __webpack_exec__(43868); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);